let notificationMessage;
self.addEventListener('push', function (event) {
    notificationMessage = JSON.parse(event.data.text()).notification;
    const options = {
        body: notificationMessage.body,
        image: self.location.origin + notificationMessage.image,
    };

    event.waitUntil(
        self.registration.showNotification(notificationMessage.title, options)
    );
});

self.addEventListener('notificationclick', function (event) {
    event.notification.close();
    event.waitUntil(
        clients.openWindow(notificationMessage.data.url)
    );
});